import EpgEvent from '../../classes/epgEvent';
import Event from '../../classes/event';
import FastEvent from '../../classes/fastEvent';
import Modals from '../../types/enums/modals';
import Pages from '@pages';
import ParentalUtils from '../../utils/parental';
import { pushRoute } from '../../store/thunks/route.thunk';
import { setModal, setModalParams } from '../../store/slices/modal.slice';
import { store } from '../../store/store';

function goToDetail(item: FastEvent | EpgEvent | Event) {
  const { media } = store.getState();

  const pushDetail = () =>
    store.dispatch(
      pushRoute({
        route: { Page: Pages.DETAIL },
        params: {
          current: {
            asset: item,
          },
          push: true,
          stack: { position: !media.live ? media.currentTime : undefined },
        },
      })
    );
  if (ParentalUtils.isAdultRestricted(item as Event)) {
    store.dispatch(setModalParams({ callback: pushDetail }));
    store.dispatch(setModal(Modals.PARENTAL_PIN_GENERIC));
  } else {
    pushDetail();
  }
}

export default goToDetail;
